import React from 'react';
import DropZone from '@src/new-components/DropZone';
import { COLOR } from '@src/styles/color';
import { Box } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';

const IdentityUpload = ({
  label,
  error,
  helperText,
  onDrop,
  file,
  disabled,
}) => {
  const { t } = useTranslation();
  const renderStatus = () => {
    if (disabled) {
      return (
        <Box className="identity-uploaded">
          <Typography variant="body-14-medium" color={COLOR.black.default}>
            {t('uploadedV2')}
          </Typography>
        </Box>
      );
    }
    if (file) {
      return (
        <Box className="identity-upload-file">
          <img src={file} alt="identity" />
        </Box>
      );
    }
    return (
      <Box
        className={`identity-upload-icon ${
          error ? 'identity-upload-error' : ''
        }`}
        aria-invalid={error}
      >
        <AddRounded />
      </Box>
    );
  };
  return (
    <Box className="identity-upload-container">
      <Typography className="input-label">{label}</Typography>
      <DropZone
        onDrop={onDrop}
        accept="image/*"
        disabled={disabled}
        height={114}
        background
        sx={{
          borderRadius: '12px',
          backgroundColor: COLOR.white,
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
          cursor: disabled ? '' : 'pointer',
        }}
        validatorKeys={[]}
      >
        {renderStatus()}
      </DropZone>
      {error && <Typography className="input-error">{helperText}</Typography>}
    </Box>
  );
};

export default IdentityUpload;
